export default "__VITE_ASSET__C2kHv0pA__"